export default "__VITE_ASSET__UeWqu$bT__"